import { render, staticRenderFns } from "./PolonElement.vue?vue&type=template&id=be29c7f0&scoped=true&"
import script from "./PolonElement.vue?vue&type=script&lang=js&"
export * from "./PolonElement.vue?vue&type=script&lang=js&"
import style0 from "./PolonElement.vue?vue&type=style&index=0&id=be29c7f0&scoped=true&lang=scss&"
import style1 from "./PolonElement.vue?vue&type=style&index=1&id=be29c7f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be29c7f0",
  null
  
)

export default component.exports